// Dependencies.
import styled from 'styled-components'

export const ModalContent = styled.div`
  position: relative;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
  max-width: 90%;
  width: 600px;
  pointer-events: auto;
  margin: auto;
`
// Modal Content.
export const ModalContentWrapper = styled(ModalContent)`
  margin-top: 20vmin;
  margin-bottom: 20vmin;
  /* min-height: 470px; */
`

export const ModalContentWrapperVideo = styled.div`
  position: relative;
  margin: auto;
  padding-top: 20px;
  padding-bottom: 20px;
  min-height: 470px;
  max-width: 90%;
  width: 800px;
`

/**
 * In cases where we want to stack multiple white modal sections
 * We should use:
 * <ModalMultiContentWrapper>
 *   <ModalContentMultiWrapper/>
 * <ModalContentMultiWrapper/>
 * </ModalMultiContentWrapper>
 */
export const ModalMultiContentWrapper = styled.div`
  position: relative;
  margin: auto;
  margin-top: 20vmin;
  margin-bottom: 20vmin;
  /* min-height: 470px; */
  max-width: 90%;
  pointer-events: auto;
  width: 600px;
`

export const ModalMultiContent = styled.div`
  position: relative;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
  margin: auto;
  max-width: 100%;
  pointer-events: auto;
  width: 600px;
`
